// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { hideElement, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

signInResetPasswordFormStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        gap: 10px;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
        }
    `,
};

signInResetPasswordFormStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        min-height: 34px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

signInResetPasswordFormStyles.sendButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

signInResetPasswordFormStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};
